import axios from '../utilities/axios'

const EPIC_TICKET = 'epic_v1'

function saveUserTicket(payload) {
  return localStorage.setItem(EPIC_TICKET, payload)
}

function getUserTicket() {
  const ticket = localStorage.getItem(EPIC_TICKET)
  return JSON.parse(ticket) || null
}

function removeUserTicket() {
  return localStorage.removeItem(EPIC_TICKET)
}

function activateGame(payload) {
  const { contentId, couponCode } = payload
  const ticket = this.getUserTicket()
  return axios.post('/api/v1/epic/content/activate', { ticket, contentId, couponCode })
}

function getLoginAuthUrl() {
  const [baseUrl, clientId, paramUrl, redirectUrl, stateUrl] = [
    process.env.RAZZLE_EPIC_LOGIN_URL,
    process.env.RAZZLE_EPIC_CLIENT_ID,
    '&response_type=code&scope=basic_profile',
    `&redirect_uri=${encodeURI(document.location.protocol)}//${encodeURI(
      document.location.host
    )}/epic-redirect`,
    '&state=rfGWJux2WL86Zxr6nKApCAnDo8KexEUE',
  ]
  return `${baseUrl}?client_id=${clientId}${paramUrl}${redirectUrl}${stateUrl}`
}

export default {
  saveUserTicket,
  getUserTicket,
  removeUserTicket,
  activateGame,
  getLoginAuthUrl,
}
